angular.module('ui.user.settings', [])

    .config(function ($stateProvider, customTemplateResolverProvider) {

        $stateProvider.state('client.settings', {
            url: '/settings',
            template: customTemplateResolverProvider.get('settings.html', 'app/ui/user/settings/settings.html'),
            controller: 'UserSettingsController',
            data: {pageTitle: 'OrderManager: User Settings'}
        });

    })

    .controller('UserSettingsController', function ($scope, $state, gettextCatalog, toastr, userSettings, gridTextSearchService) {
        $scope.tabs = [
            "app/ui/user/settings/tabs/gridSettings.html",
            "app/ui/user/settings/tabs/otherSettings.html"
        ];

        function initSettings() {
            userSettings.getSettings().then(function(settings) {
                $scope.settings = settings;

                $scope.treeDataSource = { data: new kendo.observableHierarchy($scope.settings.gridSettings.textSearchFields) };
                $scope.treeOptions = {
                    checkboxes: {
                        checkChildren: true
                    },
                    loadOnDemand: false
                };
            });
        }

        initSettings();

        $scope.save = function () {
            userSettings.getSettings().then(function(settings) {
                settings.gridSettings.textSearchFields = $scope.treeDataSource.data.toJSON(); //Method of the kendo.observableHierarchy object to return initial structure
                userSettings.save();
                
                gridTextSearchService.fixGridTextSearchConfig(); // to delete empty `items` collections
                
                $state.go('client.home'); // redirect back to home
                toastr.success(gettextCatalog.getString('User settings saved!'));
            });
        };

        $scope.cancel = function () {
            userSettings.getSettings().then(function(settings) {
                $scope.treeDataSource = kendo.observableHierarchy(settings.gridSettings.textSearchFields);
                $state.go('client.home'); // redirect back to home
            });
        };
    })

;
